module.exports = __webpack_public_path__ + "img/kongsberg_horizontal_light.aa034460.png";